export const UPDATE_JURIDICAL_PERSON_ATTEMPT = 'UPDATE_JURIDICAL_PERSON_ATTEMPT';
export type UPDATE_JURIDICAL_PERSON_ATTEMPT = typeof UPDATE_JURIDICAL_PERSON_ATTEMPT;

export const UPDATE_JURIDICAL_PERSON_SUCCESS = 'UPDATE_JURIDICAL_PERSON_SUCCESS';
export type UPDATE_JURIDICAL_PERSON_SUCCESS = typeof UPDATE_JURIDICAL_PERSON_SUCCESS;

export const UPDATE_JURIDICAL_PERSON_FAILURE = 'UPDATE_JURIDICAL_PERSON_FAILURE';
export type UPDATE_JURIDICAL_PERSON_FAILURE = typeof UPDATE_JURIDICAL_PERSON_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/juridical-person/update/Types.tsx